<template>
  <div class="people-satoshi">
    <People
    :isReverse="false" 
    :image="require('../assets/people_satoshi/hero.jpg')" 
    :name="require('../assets/people_satoshi/name.svg')" 
    mainCatch="AI、IoT、データサイエンス。<br class='over_display'>
            大学教授ともタッグを組み、<br>
            「知」の力で<br>
            ブレイクスルーを起こす。" 
    background="デジタル戦略支援事業部<br>
              副事業部長<br>
              エグゼクティブコンサルタント" 
    history="「要求開発や上流工程に携わりたい」と、豆蔵に中途入社。公共系の部署に配属になり、総務省の人材育成プロジェクトに参画。AIやビッグデータを扱うエンジニアを国としてどう育成していくのか、その教育カリキュラムを作成。また、オープンデータに関する実証実験や小中学校等での教育クラウドに関する調査研究も手掛けた。現在は、AIやIoT関連の先端技術に特化した事業組織を率いている。なお、大学時代は物理学を専攻。研究テーマは、高エネルギー宇宙線。" 
    >
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              AI、IoT、データサイエンスの技術で、<br>
              あらゆる業種のクライアントを進化させる。
            </p>
            <p class="body">
              私がマネジメントしている「デジタル戦略支援事業部」は、一言でいえば、<i>「先端技術を活用して、クライアント企業を進化させる部署」</i>です。AI、IoT、データサイエンスなどのテクノロジーを用いて、金融業、製造業、商社、サービス業など、あらゆる業種のクライアントの支援を行っています。クライアントと一緒に新しいサービスを共創したり、私たちがコンサルタントとして事業における課題を解決したり。また、豆蔵の自社開発プロダクトである、対話型AIエンジン『MZbot™️』を活用して課題を解決したり、RPAの導入を支援することもあります。<i>支援するクライアントの業種も、導入する技術も幅広いので、多種多様なソリューションを世へ送り出すことに関われる</i>ことが、この事業部の特長です。
            </p>
            <p class="catch">
              事業部のモットーは、「知は力なり」。
            </p>
            <p class="body">
              では、クライアントとどのようにゴールを設定しているのか。これまでのシステム企画・開発とは違って、デジタルトランスフォーメーションを伴うシステム開発は、企画の段階では、要件を明確に定義できるわけではありません。最新テクノロジーを用いて、これまでに無い価値を生み出すので、クライアント側もゴールのイメージが明確ではないことがほとんど。<i>デザイン思考やリーン/アジャイル開発の企画・開発手法を用いて、ブレーンストーミングやワークショップを開催</i>しながら、アイディアを創出しながら形作っていくことが多いです。この初動におけるカギは、プロジェクトをリードするコンサルタントが、先行事例や技術情報をどれだけインプットできているかにあります。まさに「知は力なり」。これは、私たちの事業部がモットーとして掲げている言葉です。<i>書籍や論文からのインプットを奨励するのはもちろんのこと、海外で開催されるカンファレンスへの出席も勧めています。</i>
            </p>' 
        :image="require('../assets/people_satoshi/image01.jpg')" 
      />
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              大学の研究者との連携で、<br>
              独自の未来を描いて実現する。
            </p>
            <p class="body">
              最先端の「知」へとアプローチするために、大学と連携することも多いです。豆蔵は、AI、データサイエンスの専門家で「攻殻機動隊REALIZE PROJECT」などを手掛けた、<i>村上 和彰 九州大学名誉教授を最高科学技術顧問に迎えています。</i>他にも、一橋大学や九州工業大学の教授陣と産学連携プロジェクトを通して、新しい試みにチャレンジし続けています。その一例として、九州工業大学の井上 創造准教授とクライアント企業が推進している、介護事業者向けの「IoTセンサーによる行動センシング」の共同研究が挙げられます。<i>我々は教授・研究者が培ってきた要素技術（AIや機械学習）やデジタルマーケティング等の専門的な知見と、クライアント企業の事業テーマを掛け合わせることで、どういう未来が生まれるのか。</i>そのイメージを描いて具現化していくのも、豆蔵のコンサルタントの重要なミッションのひとつです。
            </p>
            <p class="catch">
              研究や実装に留まらず「深い定着」までを担う。
            </p>
            <p class="body">
              未来の具現化のために、豆蔵のコンサルタントは、<i>研究や実装に留まらず「定着」までを担います。</i>テクノロジーは、あくまで手段の一つであり、その導入がゴールではありません。クライアント企業にソリューションを定着させ、事業だけでなく、その先の社会にも変化をもたらす。これが私たちの目的です。その達成のために、豆蔵のコンサルタントは、当事者であるクライアントの現場社員に対して、計画的な人材育成を提供しています。単に課題解決のソリューションを提供するだけでなく、クライアントへスキルトランスファーを行うことによって、組織に定着するまでを支援しています。<i>人材育成・研修事業を展開している豆蔵だからこそ、より深い「定着」にまで踏み込むことができるのです。</i>
            </p>' 
        :image="require('../assets/people_satoshi/image02.jpg')" 
      />
      <PeopleArticle
        :isReverse="false" 
        text='<p class="catch">
              未知への挑戦を厭わない、<br>
              若手社員が活躍している。
            </p>
            <p class="body">
              「デジタル戦略支援事業部」は、AI、データサイエンス、IoT領域のソリューションを開発する部署ですから、<i>数学や統計分野に深い知見を持った社員が多く在籍しています。</i>博士号の取得者や元大学院の講師、宇宙関連の研究に携わっていた者も活躍中です。メンバーは総勢20余名。少数精鋭の事業部であり、一人ひとりが大きな裁量を持って開発を進めています。斬新なソリューションを生み出し、そのプロセスで得られた経験値を全員で共有することで、事業部としても進化を重ねています。
            </p>
            <p class="body">
              私たちの事業部が求める人物像は、<i>「未知への挑戦を厭わない人」</i>です。依頼される案件の多くは、新規サービスを検討するもので、一筋縄ではいかないものばかり。目の前の高い壁に臆することなく、自らの努力で立ち向かえる方には、合っている環境だと思います。過去の経験に頼るよりも、<i>未来を切り拓く力が求められるので、若手社員が力を発揮しやすい面もあります。</i>AIやIoTの領域では、新しい技術が日々生まれていますから、重要なのはアンテナの高さや吸収力です。実際に、新卒入社2〜3年目のコンサルタントが、猛勉強しながら中核を担っているプロジェクトが多くあります。
            </p>
            <p class="catch">
              挑戦を続けていけば、きっと、ドラえもんだってつくれる。
            </p>
            <p class="body">
              また、自社プロダクトを開発している部署でもあるので、自らの手で新しい製品を開発して、世の中を変えていきたい人にも向いている職場だと思います。弊社の対話型AIエンジン『MZbot™️』は、既にビジネスのシーンで活用していますが、さらなる拡張機能を開発していき、日常生活のシーンでも使われるようになって、『ドラえもん』のようなものの一部が実現できたらいいなと思って活動しています。豆蔵が支援しているクライアントには、日本を代表する企業も多い。大学の研究者とも一緒に知恵を出し合うことで、<i>社会の変革に積極的に関与していきたいです。</i>
            </p>' 
        :image="require('../assets/people_satoshi/image03.jpg')" 
      />
    </People>
  </div>
</template>

<script>
// @ is an alias to /src
import People from '@/components/people/People.vue';
import PeopleArticle from '@/components/people/PeopleArticle.vue';
export default {
  name: 'people-satoshi',
  components: {
    People,
    PeopleArticle
  },
}
</script>

<style lang="scss" scoped>
.people-satoshi {
  width: 100%;
  overflow: hidden;
}
</style>